import { DOCUMENT } from '@angular/common';
import {
  afterNextRender,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  input,
  output,
} from '@angular/core';

@Component({
  selector: 'app-admin-side-panel',
  standalone: true,
  template: `
    <div class="cg-side-panel-backdrop" (click)="closed.emit()" role="presentation">
      <aside
        class="cg-side-panel cg-animate-slide-in-right"
        (click)="$event.stopPropagation()"
        role="dialog"
        aria-modal="true"
        [attr.aria-labelledby]="titleId()"
      >
        <header class="cg-side-panel__header">
          @if (title()) {
            <h2 [id]="titleId()" class="cg-side-panel__title">{{ title() }}</h2>
          }
          <button type="button" class="cg-side-panel__close" aria-label="Close panel" (click)="closed.emit()">
            ×
          </button>
        </header>
        <div class="cg-side-panel__body">
          <ng-content />
        </div>
      </aside>
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `,
})
export class AdminSidePanelComponent {
  private readonly host = inject(ElementRef<HTMLElement>);
  private readonly doc = inject(DOCUMENT);
  private readonly destroyRef = inject(DestroyRef);

  readonly title = input<string>();
  readonly titleId = input('admin-side-panel-title');
  readonly closed = output<void>();

  constructor() {
    afterNextRender(() => {
      const el = this.host.nativeElement;
      this.doc.body.appendChild(el);
      this.destroyRef.onDestroy(() => el.remove());
    });
  }
}
